export default (props) => {
  const {
    target,
  } = props;

  const targetElement = document.getElementById(target);

  if (targetElement) {
   targetElement.click();
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/targetClick.js